// extracted by css-extract-rspack-plugin
export default {"header":"NdGWvdWkAs0iMUw5","licenseList":"zXAktuo7k8SFwZ8L","inputGroup":"iJf93GZmFk1fiumF"};